import React from 'react';

import { Tag } from 'antd';

type StatusBadgeProps = {
  deleted?: boolean;
  entityStatus?: string;
};

export const StatusBadge: React.FC<StatusBadgeProps> = ({ deleted, entityStatus }) => {
  if (deleted) {
    return (
      <Tag color="red" style={{ marginLeft: 8 }}>
        삭제됨
      </Tag>
    );
  }

  if (entityStatus) {
    return (
      <Tag color="orange" style={{ marginLeft: 8 }}>
        {entityStatus}
      </Tag>
    );
  }

  return null;
};
